// @ts-nocheck
export const selectEvents = state => state.event.events;
export const selectCorrespondence = state => state.event.correspondence;
export const selectEmails = state => state.event.emails;
export const selectEmailsUrl = state => state.event.emailsUrl;
